import { apiClient } from "../apiClient";

export const monHocApi = {
    getAll: () => apiClient.get(`mon-hoc`)
}